module.exports = __webpack_public_path__ + "static/media/demo-icon.7fae1afe.svg";